/* template */
<template minapp="mpx" xlang="wxml"><mpx-view :style="[(displayStyle)] | transRpxStyle" @tap="onClick" class="transition" :class='[$attrs["custom-class"],(classname)]' v-if="(inited)"><slot></slot></mpx-view></template>

/* styles */
<style lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m0d073e82"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0d073e82"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex0d073e82%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex0d073e82%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0d073e82"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index0d073e82/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
